import React from "react";
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const HowToHandleOptionsAssignmentPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans">
    {/* Hero Section */}
    <HeadersNonAuth />
      <div 
          className="relative w-full h-[300px] bg-cover bg-center flex items-center justify-center" 
          style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
          <h1 className="text-white text-4xl md:text-5xl font-bold text-center">
            How to Handle Options Assignment
          </h1>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12 space-y-8">
        <p>
          A common question from new traders is how do option exercise and assignments work?
          Options assignment occurs when the option seller/writer is obligated to fulfill their contractual
          obligation, and for Call options, the option buyer/holder exercises their right to buy the
          underlying asset, or for Put options, sell the underlying asset at the specified strike price.
        </p>
        <p>
          How you handle options assignment depends on whether you are the option buyer/holder or the
          option seller/writer. There are several ways to manage option assignment as outlined below:
        </p>

        <h2 className="text-2xl font-bold">For Option Buyers/Holders:</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>
            <strong>Cover the Position:</strong>
            <p className="ml-4">
              If you're assigned on a call option, you may cover the position by purchasing the underlying asset at the market price.
            </p>
            <p className="ml-4">
              If assigned on a put option, you may cover the position by selling the underlying asset at the market price.
            </p>
          </li>
          <li>
            <strong>Close the Option Position:</strong>
            <p className="ml-4">
              Another option is to close the option position by selling the call or put option in the market before it expires.
              You may do this if you don't want to take a position in the underlying asset.
            </p>
          </li>
        </ol>

        <h2 className="text-2xl font-bold">For Option Sellers/Writers:</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>
            <strong>Fulfill Your Obligation:</strong>
            <p className="ml-4">
              If you're assigned on a call option you wrote, you must sell the underlying asset at the agreed-upon strike price.
            </p>
            <p className="ml-4">
              If assigned on a put option you wrote, you must buy the underlying asset at the strike price.
            </p>
          </li>
          <li>
            <strong>Have Sufficient Capital:</strong>
            <p className="ml-4">
              You must ensure you have enough capital in your account to fulfill your obligations. If not, you might need to
              close out the position or adjust your strategy.
            </p>
          </li>
          <li>
            <strong>Close the Position:</strong>
            <p className="ml-4">
              You can also close out the position by buying back the call or put option in the market prior to expiration.
              This might be a preferable choice if you want to avoid taking a position in the underlying asset.
            </p>
          </li>
          <li>
            <strong>Roll the Position:</strong>
            <p className="ml-4">
              In some cases, you may choose to "roll" the position by buying back the option that was assigned and simultaneously
              selling another option with a different expiration date or strike price.
            </p>
          </li>
          <li>
            <strong>Evaluate Tax Implications:</strong>
            <p className="ml-4">
              Keep in mind the tax implications of the assignment, as it may trigger capital gains or losses.
            </p>
          </li>
        </ol>

        <h2 className="text-2xl font-bold">General Tips:</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Understand Your Obligations:</strong> Understand the terms of the contract and your role in the trade.</li>
          <li><strong>Monitor Positions:</strong> Regularly check your options positions, especially near expiration dates.</li>
          <li><strong>Have a Plan:</strong> Know how you will handle assignments before you enter the trade.</li>
          <li><strong>Stay Informed:</strong> Follow market updates and corporate events that may affect options contracts.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8">Example Assignments with Quantum Flo:</h2>
        <ol className="list-decimal list-inside space-y-4">
          <li>
            Buy a $450 Call on SPY expiring the same day. If the price ends above $450, you’ll be assigned 100 shares
            at $450 per share. You must have $45,000 in your account. You may sell before expiry or hold to take delivery.
          </li>
          <li>
            Buy a $450 Put on SPY expiring the same day. If the price drops below $450, you’ll be assigned a short
            position of 100 shares. This requires sufficient capital and understanding of your broker’s short position rules.
          </li>
        </ol>

        <p>
          As a buyer, you control whether to exercise or sell the option. JTNC advises closing trades before expiry to
          avoid fees or unpredictable outcomes. However, some situations may justify taking delivery.
        </p>

        <p>
          JTNC will soon introduce complex strategies like strangles, butterflies, and condors. These techniques help
          diversify approaches and improve risk-adjusted returns. We’re here to help you become a better trader.
        </p>
      </div>
    </div>
  );
}

export default HowToHandleOptionsAssignmentPage;
